// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
export function debounce<TFunc extends (...args: any[]) => void>(
  func: TFunc,
  wait: number,
  immediate: boolean,
): TFunc {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  let timeout;
  const d = function () {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const context = this;
    // eslint-disable-next-line prefer-rest-params
    const args = arguments;
    const later = function () {
      timeout = null;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      if (!immediate) func.apply(context, args);
    };
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    const callNow = immediate && !timeout;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    if (callNow) func.apply(context, args);
  };

  return d as TFunc;
}

export const debouncedLog = debounce(
  console.log,
  100,
  true,
) as typeof console.log;
